/** @format — Per-conversation chat composer drafts (localStorage) */

import { STORAGE_KEYS } from "@/services/constants";

const DEBOUNCE_MS = 300;

function readAllDrafts() {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.CHAT_INPUT_DRAFTS);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function persistAllDrafts(drafts) {
  try {
    localStorage.setItem(STORAGE_KEYS.CHAT_INPUT_DRAFTS, JSON.stringify(drafts));
  } catch {
    // Quota or private mode — ignore.
  }
}

export function readChatDraft(conversationId) {
  if (!conversationId) return "";
  const value = readAllDrafts()[conversationId];
  return typeof value === "string" ? value : "";
}

export function writeChatDraft(conversationId, text) {
  if (!conversationId) return;
  const drafts = readAllDrafts();
  const next = typeof text === "string" ? text : "";
  if (!next.trim()) {
    delete drafts[conversationId];
  } else {
    drafts[conversationId] = next;
  }
  persistAllDrafts(drafts);
}

export function clearChatDraft(conversationId) {
  writeChatDraft(conversationId, "");
}

export { DEBOUNCE_MS as CHAT_DRAFT_DEBOUNCE_MS };
